import { FixedOperationsState } from './fixed-operations.interfaces';
import { FixedOperationsAction } from './fixed-operations.actions';
import { reducer as appointmentReducer } from './appointments/appointments.reducer';
import { reducer as workOrderReducer } from './work-orders/work-orders.reducer';
import { reducer as quoteReducer } from './quotes/quotes.reducer';
import { combineReducers } from '@ngrx/store';
export function fixedOperationsReducer(
  state: FixedOperationsState,
  action: FixedOperationsAction
): FixedOperationsState {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

const myReducers = {
  appointments: appointmentReducer,
  workOrders: workOrderReducer,
  quotes: quoteReducer,
  fixedOperationsReducer
};

export function createReducer(asyncReducers = {}) {
  let allReducers = Object.assign(myReducers, asyncReducers);
  return combineReducers(allReducers);
}

export function appReducer(state: any, action: any) {
  return createReducer()(state, action);
}

export const reducer = combineReducers(myReducers);
